<template>
  <ol
    class="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3"
    :aria-label="t('aria.workflowSteps')"
    data-testid="workflow-stepper"
  >
    <li v-for="(step, idx) in steps" :key="step.id" class="h-full">
      <WorkflowStepCard
        :index="step.index"
        :title="step.title"
        :subtitle="step.subtitle"
        :receives="step.receives"
        :receives-label="receivesLabel"
        :is-current="current !== null && idx === current"
        :is-past="current !== null && idx < current"
      />
    </li>
  </ol>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import WorkflowStepCard from '@/components/domain/WorkflowStepCard.vue';
import type { WorkflowStepItem } from '@/types/component-types';

export type { WorkflowStepItem } from '@/types/component-types';

const { t } = useI18n();

interface Props {
  steps: readonly WorkflowStepItem[];
  current?: number | null;
  receivesLabel: string;
}

withDefaults(defineProps<Props>(), {
  current: null,
});
</script>
